import React from "react";

import LayoutModal from "../../../common/components/layouts/LayoutModal";
import Program from "../components/Program";
import AddNewProgram from "../components/AddNewProgram";
import Button from "../../../../lib/components/Button";
import RadioButton from "../../../../lib/components/RadioButton/RadioButton";
import "./EducationModal.css";

export default function EducationModalComponent({
  selectedProgram,
  setSelectedProgram,
  isAddNewVisible,
  setIsAddNewVisible,
  associatedPrograms,
  domesticPrograms,
  saveToProfile,
  showEducationModal,
  setShowEducationModal,
  programsExists,
}) {
  const renderPrograms = () => {
    return (
      <div className="pt-2 space-y-4 animate-fade-in">
        <div className="animate-fade-in">
          <h1 className="font-sans text-xl font-semibold text-secondary">
            Select a Program
          </h1>
          <div className="px-2">
            {associatedPrograms &&
              associatedPrograms.alumnus?.map((program, id) => (
                <RadioButton
                  name={"programSelect"}
                  labelClass={"flex flex-row items-center gap-3"}
                  value={program}
                  id={id}
                  onChange={() => {
                    setSelectedProgram(program);
                  }}
                  checked={selectedProgram}
                  bodyClassName={"w-full"}
                  body={
                    <Program
                      courseName={program.courseName}
                      startYearMonth={program.intake.date}
                      endYearMonth={program.completion.date}
                      marks={program.marks}
                      marksType={program.marksType}
                    />
                  }
                />
              ))}
            {associatedPrograms &&
              associatedPrograms.enrolled?.map((program, id) => (
                <RadioButton
                  name={"programSelect"}
                  labelClass={"flex flex-row items-center gap-3"}
                  value={program}
                  id={id}
                  onChange={() => {
                    setSelectedProgram(program);
                  }}
                  checked={selectedProgram}
                  bodyClassName={"w-full"}
                  body={
                    <Program
                      courseName={program.courseName}
                      startYearMonth={program.intake.date}
                      endYearMonth={program.completion.date}
                      marks={program.marks}
                      marksType={program.marksType}
                    />
                  }
                />
              ))}
            {domesticPrograms &&
              domesticPrograms.alumnus?.map((program, id) => (
                <RadioButton
                  name={"programSelect"}
                  labelClass={"flex flex-row items-center gap-3"}
                  value={program}
                  id={id}
                  onChange={() => {
                    setSelectedProgram(program);
                  }}
                  checked={selectedProgram}
                  bodyClassName={"w-full"}
                  body={
                    <Program
                      courseName={program.courseName}
                      startYearMonth={program.intake.date}
                      endYearMonth={program.completion.date}
                      marks={program.marks}
                      marksType={program.marksType}
                    />
                  }
                />
              ))}
            {domesticPrograms &&
              domesticPrograms.enrolled?.map((program, id) => (
                <RadioButton
                  name={"programSelect"}
                  labelClass={"flex flex-row items-center gap-3"}
                  value={program}
                  id={id}
                  onChange={() => {
                    setSelectedProgram(program);
                  }}
                  checked={selectedProgram}
                  bodyClassName={"w-full"}
                  body={
                    <Program
                      courseName={program.courseName}
                      startYearMonth={program.intake.date}
                      endYearMonth={program.completion.date}
                      marks={program.marks}
                      marksType={program.marksType}
                    />
                  }
                />
              ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <LayoutModal
      showModal={showEducationModal}
      setShowModal={setShowEducationModal}
      showCloseIcon={true}
      className="flex flex-col justify-between p-10 h-full md:w-160"
    >
      <LayoutModal.Body>
        <div className="relative">
          <div>
            <h1 className="pb-2 font-sans text-2xl font-bold text-secondary">
              Add to Profile
            </h1>
            <div className="pb-4">
              <AddNewProgram
                setShowEducationModal={setShowEducationModal}
                isAddNewVisible={isAddNewVisible}
                setIsAddNewVisible={setIsAddNewVisible}
              />
            </div>
            {/* {Show Programs} */}
            {isAddNewVisible && programsExists() && (
              <div id="list-program-container">{renderPrograms()}</div>
            )}
          </div>
          {isAddNewVisible && programsExists() && (
            <div className="sticky bottom-0 pt-2 bg-white">
              <Button
                size="responsive-base"
                customContainerClass="w-full"
                disabled={!Boolean(selectedProgram)}
                onClick={() => saveToProfile()}
              >
                <span className="px-2 font-serif text-base font-semibold tracking-tight">
                  Save Score
                </span>
              </Button>
            </div>
          )}
        </div>
      </LayoutModal.Body>
    </LayoutModal>
  );
}
